import { useRef } from "react";
import { exportElementToPdf } from "./exportElementToPdf";

export function useClientPdf(opts = {}) {
  const pdfRef = useRef(null);

  async function exportPdf(fileName = "export.pdf") {
    if (!pdfRef.current) {
      console.error("useClientPdf: pdfRef.current is null");
      return;
    }
    await exportElementToPdf(pdfRef.current, fileName, opts);
  }

  return { pdfRef, exportPdf };
}
